import PropTypes from "prop-types";
import { useState } from "react";
import { css } from "@emotion/react";
import { em } from "@util/convertUnits";
import { Link } from "react-router-dom";
import { buttonClick } from "@util/buttonClick";

const NavBarMobileAccordian = ({ menuItem, handleMenuItemClick }) => {
	const [isOpen, setIsOpen] = useState(false);

	const ddBtn = css(`
		position: relative;
		padding-top: 2.4rem;
		padding-bottom: 2.4rem;
		font-weight: 600;
		color: #000000;

		> span {
			position: absolute;
			right: 0;
			display: inline-block;
			width: 2.4rem;
			text-indent: -10rem;
			background-image: url(/images/lac-icons/lac-nav-down-arrow-indicator.svg);
			background-position: 50% 50%;
			background-repeat: no-repeat;
			overflow: hidden;
			white-space: nowrap;

			&.is-open {
				background-image: url(/images/lac-icons/lac-nav-up-arrow-indicator.svg);
			}

		}
	`);

	const ddNav = css(`

		margin: 0;
		list-style: none;

		> li {
			font-size: 13px;
			line-height: ${em(26, 14)};

			a {
				text-decoration: none;
				color: #585858
			}
		}
	`);

	const renderChildren = () => (
		<ul className="px-3 px-ns-4" css={ddNav}>
			{menuItem.children.map((child) => (
				<li key={`${child.name}${child.url}`}>
					<Link
						to={child.url}
						onClick={handleMenuItemClick}
					>
						{child.name}
					</Link>
				</li>
			))}
		</ul>
	);

	return (
		<li>
			<div
				className="px-3 px-ns-4"
				css={ddBtn}
				onClick={() => setIsOpen(!isOpen)}
				onKeyPress={buttonClick}
				role="button"
				tabIndex="0"
			>
				{menuItem.name} {isOpen ? <span className="mr-3 mr-ns-4 is-open">collapse</span> : <span className="mr-3 mr-ns-4 is-closed">expand</span>}
			</div>
			{isOpen && renderChildren()}
		</li>
	)
};

NavBarMobileAccordian.propTypes = {
	menuItem: PropTypes.object,
	handleMenuItemClick: PropTypes.func,
};

export default NavBarMobileAccordian;